import styled from 'styled-components'
import { blue } from '../../../color'

export const TitleModal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title-modal {
    font-size: 14px;
    font-weight: 500;
    color: ${blue};
  }
`

export const SelectList = styled.div`
  max-height: 80px;
  overflow-y: auto;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;

  .tag-selected {
    border-radius: 35px;
    padding: 3px 8px 3px 4px;
    display: flex;
    margin-right: 0;
    align-items: center;
  }
`

export const SelectTitle = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
